import * as general from '../../general';

export enum ssoMethod {
  null,
  'Google',
  'Vinci-AzureAD',
  'Equans-AzureAD',
  'Freyssinet-AzureAD'
}

export const customSsoMethod = [
  ssoMethod['Vinci-AzureAD'],
  ssoMethod['Equans-AzureAD'],
  ssoMethod['Freyssinet-AzureAD']
];

export interface ssoCheckRequest {
    email?: string;
}

export function ssoCheckSuccess(ssoMethod: ssoMethod): general.SuccessReturnBody {
  return general.getSuccessReturnBody(ssoMethod);
}

export function ssoCheckServerError(): general.ServerErrorReturnBody {
  return general.getServerErrorReturnBody();
}
